import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/cs-mobile-next/app/(main)/article/CrazysalesWarrantyPolicy/page.tsx");
